__turbopack_context__.v({
  "catchImageOverlay": "HeaderSection-module__sdqhgG__catchImageOverlay",
  "catchImageWrapper": "HeaderSection-module__sdqhgG__catchImageWrapper",
  "catchImagesGrid": "HeaderSection-module__sdqhgG__catchImagesGrid",
});
